[
  {
    "key": "utilization",
    "label": "Utilisation quotidienne des camions",
    "component": "FleetUtilizationCard",
    "metrics": [
      {
        "label": "Heures planifiées / dispatch",
        "field": "fleetUtilizationWorkedMinutes",
        "unit": "min"
      },
      {
        "label": "Heures max / dispatch",
        "field": "fleetUtilizationMaxWorkMinutes",
        "unit": "min"
      },
      {
        "label": "Utilisation globale",
        "field": "fleetRetainedUtilizationPct",
        "unit": "%"
      }
    ]
  },
  {
    "key": "peak_load",
    "label": "Remplissage maximal moyen des camions utilisés",
    "component": "MiniLoadPerformanceCard",
    "metrics": [
      {
        "label": "Remplissage maximal moyen",
        "field": "avgPeakLoadFillRatePct",
        "unit": "%"
      },
      {
        "label": "Temps assigné moyen",
        "field": "avgAssignedDurationMinutes",
        "unit": "min"
      },
      {
        "label": "Occupation moyenne",
        "field": "avgTimeBudgetConsumedPct",
        "unit": "%"
      },
      {
        "label": "Camions utilisés parmi les actifs",
        "field": "usedFleetPct",
        "unit": "%"
      }
    ]
  },
  {
    "key": "occupation",
    "label": "Occupation et utilisation des camions",
    "component": "TrendCard",
    "metrics": [
      {
        "label": "Occupation moyenne",
        "field": "avgTimeBudgetConsumedPct",
        "unit": "%"
      },
      {
        "label": "Flotte mobilisée",
        "field": "usedFleetPct",
        "unit": "%"
      },
      {
        "label": "Temps assigné",
        "field": "avgAssignedDurationMinutes",
        "unit": "min"
      },
      {
        "label": "Camions actifs",
        "field": "activeTruckCount",
        "unit": ""
      },
      {
        "label": "Camions mobilisés",
        "field": "usedTruckCount",
        "unit": ""
      }
    ],
    "history_metrics": [
      {
        "label": "Occupation moyenne de la flotte",
        "field": "avgTruckOccupancyPct",
        "unit": "%"
      },
      {
        "label": "Flotte utilisée",
        "field": "avgFleetUsagePct",
        "unit": "%"
      }
    ]
  },
  {
    "key": "tonnage",
    "label": "Tonnage quotidien",
    "component": "TonnageCard",
    "metrics": [
      {
        "label": "Tonnage moyen / dispatch",
        "field": "avgPlannedTonnageTons",
        "unit": "t"
      },
      {
        "label": "Commandes / dispatch",
        "field": "avgDispatchOrderCount",
        "unit": ""
      },
      {
        "label": "Tonnes / camion",
        "field": "avgTonnagePerUsedTruckTons",
        "unit": "t"
      },
      {
        "label": "Tonnes / client",
        "field": "avgTonsPerDeliveryStopTons",
        "unit": "t"
      },
      {
        "label": "Produits",
        "field": "dispatchProductCount",
        "unit": ""
      },
      {
        "label": "Compartiments / camion",
        "field": "avgCompartmentsUsed",
        "unit": ""
      },
      {
        "label": "Capacité déclarée",
        "field": "totalCompartments",
        "unit": ""
      }
    ]
  },
  {
    "key": "compartments",
    "label": "Compartiments",
    "component": "CompartmentsOverviewCard",
    "metrics": [
      {
        "label": "Compartiments utilisés",
        "field": "avgCompartmentUsagePct",
        "unit": "%"
      },
      {
        "label": "Remplissage moyen",
        "field": "avgCompartmentFillPct",
        "unit": "%"
      },
      {
        "label": "Compartiments / camion",
        "field": "avgCompartmentsUsed",
        "unit": ""
      },
      {
        "label": "Capacité déclarée",
        "field": "totalCompartments",
        "unit": ""
      }
    ]
  },
  {
    "key": "client_visits",
    "label": "Visites clients",
    "component": "MiniClientStopsCard",
    "metrics": [
      {
        "label": "Arrêts / camion",
        "field": "avgBusinessStopCountPerUsedTruck",
        "unit": ""
      },
      {
        "label": "Camions utilisés",
        "field": "usedTruckCount",
        "unit": ""
      },
      {
        "label": "Camions utilisés parmi les actifs",
        "field": "usedFleetPct",
        "unit": "%"
      },
      {
        "label": "Temps route chargé",
        "field": "avgHighLoadDriveSharePct",
        "unit": "%"
      },
      {
        "label": "Tonnes / client",
        "field": "avgTonsPerDeliveryStopTons",
        "unit": "t"
      },
      {
        "label": "Camions actifs",
        "field": "activeTruckCount",
        "unit": ""
      },
      {
        "label": "Distance / camion",
        "field": "avgDistancePerUsedTruckKm",
        "unit": "km"
      },
      {
        "label": "Temps assigné moyen",
        "field": "avgAssignedDurationMinutes",
        "unit": "min"
      },
      {
        "label": "Tonnes / camion",
        "field": "avgTonnagePerUsedTruckTons",
        "unit": "t"
      }
    ]
  },
  {
    "key": "truck_average",
    "label": "Camion moyen",
    "component": "TruckAverageCard",
    "metrics": [
      {
        "label": "Tonnes / camion",
        "field": "avgTonnagePerUsedTruckTons",
        "unit": "t"
      },
      {
        "label": "Km / camion",
        "field": "avgDistancePerUsedTruckKm",
        "unit": "km"
      },
      {
        "label": "Voyages / camion actif",
        "field": "avgDeliveryVisitCountPerActiveTruck",
        "unit": ""
      },
      {
        "label": "Part des km chargés (≥25 %)",
        "field": "loadedDistancePct",
        "unit": "%"
      },
      {
        "label": "Part des km à vide / faible charge (<25 %)",
        "field": "lowLoadDistancePct",
        "unit": "%"
      },
      {
        "label": "Visites de livraison",
        "field": "deliveryVisitCount",
        "unit": ""
      },
      {
        "label": "Arrêts / camion",
        "field": "avgBusinessStopCountPerUsedTruck",
        "unit": ""
      },
      {
        "label": "Temps assigné moyen",
        "field": "avgAssignedDurationMinutes",
        "unit": "min"
      },
      {
        "label": "Km faible charge",
        "field": "lowLoadDistanceKm",
        "unit": "km"
      },
      {
        "label": "Km classifiés",
        "field": "classifiedDistanceKm",
        "unit": "km"
      },
      {
        "label": "Camions actifs (Σ)",
        "field": "totalActiveTruckCount",
        "unit": ""
      }
    ]
  },
  {
    "key": "dispatch_structure",
    "label": "Structure du dispatch",
    "component": "DispatchMixCard",
    "metrics": [
      {
        "label": "Coût du dispatch",
        "field": "realCostPerDispatchCad",
        "unit": "$ CA"
      },
      {
        "label": "Préchargement des camions",
        "field": "preloadTruckPct",
        "unit": "%"
      },
      {
        "label": "Heure + priorité",
        "field": "priorityWindowTruckPct",
        "unit": "%"
      },
      {
        "label": "Commandes protégées",
        "field": "protectedOrderPct",
        "unit": "%"
      },
      {
        "label": "Camions utilisés",
        "field": "usedTruckCount",
        "unit": ""
      },
      {
        "label": "Camions actifs",
        "field": "activeTruckCount",
        "unit": ""
      },
      {
        "label": "Commandes / dispatch",
        "field": "avgDispatchOrderCount",
        "unit": ""
      },
      {
        "label": "Produits",
        "field": "dispatchProductCount",
        "unit": ""
      },
      {
        "label": "Camions avec préchargement",
        "field": "preloadTruckCount",
        "unit": ""
      },
      {
        "label": "Camions heure + priorité",
        "field": "priorityWindowTruckCount",
        "unit": ""
      },
      {
        "label": "Commandes protégées (nombre)",
        "field": "protectedOrderCount",
        "unit": ""
      },
      {
        "label": "Commandes visibles",
        "field": "protectedOrderTotalCount",
        "unit": ""
      },
      {
        "label": "Flotte mobilisée",
        "field": "usedFleetPct",
        "unit": "%"
      },
      {
        "label": "Tonnes / client",
        "field": "avgTonsPerDeliveryStopTons",
        "unit": "t"
      }
    ]
  }
]
